import { checkNum } from './checkNum';

const DEFAULT_BASE_WIDTH = 375;

/**
 * 构造定位样式对象
 * @param {object} position 定位信息（top/bottom/left/right/centerOffset）
 * @param {number} [baseWidth=375] 设计稿基准宽度（H5: 375, PC: 960）
 * @returns {object} CSS 样式对象（vw 单位）
 */
export function buildPositionStyle(position, baseWidth = DEFAULT_BASE_WIDTH) {
    const style = {};
    const toVw = (val) => ((val / baseWidth) * 100).toFixed(2);

    if (checkNum(position.top)) {
        style.top = `${toVw(position.top)}vw`;
    }
    if (checkNum(position.bottom)) {
        style.bottom = `${toVw(position.bottom)}vw`;
    }
    // 中轴线定位（centerOffset）优先于 left/right
    if (checkNum(position.centerOffset)) {
        style.left = '50%';
        style.transform = `translateX(calc(-50% + ${toVw(position.centerOffset)}vw))`;
    } else {
        if (checkNum(position.left)) {
            style.left = `${toVw(position.left)}vw`;
        }
        if (checkNum(position.right)) {
            style.right = `${toVw(position.right)}vw`;
        }
    }
    return style;
}
